export default __webpack_public_path__ + "static/media/ઉન્નતિ જીપીડીપી માર્ગદર્શિકા અને પત્રકો 14 Oct 2019.3e87cd95.pdf";